const generateRandomString = length => {
	let characters = 'abcdefghijklmnopqrstuvwxyzABCEFGHIJKLMNOPQRSTUVWXYZ0123456789'
	let randomString = ''
	for (let i = 0; i < length; i++) {
		randomString += characters[Math.floor(Math.random() * characters.length)]
	}
	return randomString
}

export { generateRandomString }